/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaBlogPostsResponse } from '../../models/media-blog-posts-response';

export interface SearchMediaBlogPosts$Params {
  page: number;
  pageSize: number;
  query: string;
}

export function searchMediaBlogPosts(http: HttpClient, rootUrl: string, params: SearchMediaBlogPosts$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaBlogPostsResponse>> {
  const rb = new RequestBuilder(rootUrl, searchMediaBlogPosts.PATH, 'post');
  if (params) {
    rb.path('page', params.page, {});
    rb.path('pageSize', params.pageSize, {});
    rb.path('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MediaBlogPostsResponse>;
    })
  );
}

searchMediaBlogPosts.PATH = '/rest/media/blog-post/search/{page}/{pageSize}/{query}';
